import React, { useState } from "react";
import DatePicker from "react-datepicker";
import {
    isSameWeek,
    getDay,
    isValid
  } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import "./WeekPicker.scss";

const WeekPicker = ({startDay, weekStartDate, setWeekStartDate, maxDate}) => {
    const [hoveredDate, setHoveredDate] = useState(null);
    // Convert from backend's 1–7 system (1 = Monday) to JS 0–6 (0 = Sunday)
    const sanitizedWeekStart = startDay % 7;
    // Allow only the specified day to be selected
    const isAllowedStartDay = (date) => getDay(date) === sanitizedWeekStart;

    const highlightWeek = (date) => {
        const isHoveredWeek = hoveredDate
        ? isSameWeek(date, hoveredDate, { weekStartsOn: sanitizedWeekStart })
        : false;
    
      const isSelectedWeek = weekStartDate
        ? isSameWeek(date, weekStartDate, { weekStartsOn: sanitizedWeekStart })
        : false;
    
      if (isSelectedWeek) return "selected-week";
      if (isHoveredWeek) return "hovered-week";
      return undefined;
    };

    const handleChange = (date) => {
        setWeekStartDate(date);
    };

    return (
        <>
            <DatePicker
                wrapperClassName='picker'
                popperClassName='week-picker-popper'
                className="basic-form__text-box picker"
                dateFormat='dd/MM/yyyy'
                selected={weekStartDate}
                onChange={handleChange}
                filterDate={isAllowedStartDay}
                maxDate={maxDate}
                
                dayClassName={highlightWeek}
                onDayMouseEnter={(date) => isValid(date) && setHoveredDate(date)}
                onMonthMouseLeave={() => setHoveredDate(null)}
            />
        </>

    );
};

export default WeekPicker;